// extracted by mini-css-extract-plugin
module.exports = {"main":"QsrOrderEditStatus_main__xuWu4","status":"QsrOrderEditStatus_status__FLRHV","icon":"QsrOrderEditStatus_icon__5vcMx"};